export default __webpack_public_path__ + "static/media/play.212739cc.png";